module.exports = __webpack_public_path__ + "img/62.10.pH.e047f664.png";